import type {
  EngageTenantsResponse,
  EngageTenantsResult,
  EngageTenantsSummary,
} from '@reach/shared-types/engage-tenants';
import { partnerApi, type ApiResponse } from '../../../lib/api';
import { API_ENDPOINTS } from '../../../lib/constants';

export type { EngageTenantUsage, EngageTenantsSummary } from '@reach/shared-types/engage-tenants';

type EngageTenantsRequestOptions = {
  cursor?: string;
  limit?: number;
  startDate?: string;
  endDate?: string;
};

function buildUrl(path: string, options: EngageTenantsRequestOptions): string {
  const params = new URLSearchParams();
  if (options.cursor) params.append('cursor', options.cursor);
  if (options.limit) params.append('limit', options.limit.toString());
  if (options.startDate) params.append('startDate', options.startDate);
  if (options.endDate) params.append('endDate', options.endDate);

  const queryString = params.toString();
  return queryString ? `${path}?${queryString}` : path;
}

export async function fetchEngageTenants(
  options: EngageTenantsRequestOptions = {},
): Promise<EngageTenantsResult> {
  const url = buildUrl(API_ENDPOINTS.PARTNER.ENGAGE_TENANTS, options);
  const response = await partnerApi.request<ApiResponse<EngageTenantsResponse>>(url);
  const payload = response.data;
  if (!payload) {
    throw new Error('Engage tenants response missing data');
  }
  return {
    data: payload.results,
    hasNextPage: payload.pagination.hasNextPage,
    cursor: payload.pagination.cursor ?? undefined,
  };
}

export async function fetchEngageTenantsSummary(
  options: Pick<EngageTenantsRequestOptions, 'startDate' | 'endDate'> = {},
): Promise<EngageTenantsSummary> {
  const url = buildUrl(API_ENDPOINTS.PARTNER.ENGAGE_TENANTS_SUMMARY, options);
  const response = await partnerApi.request<ApiResponse<EngageTenantsSummary>>(url);
  const payload = response.data;
  if (!payload) {
    throw new Error('Engage tenants summary response missing data');
  }
  return payload;
}
